<template>
  <div class="tab-body">
    <div class="search">
      <el-row>
        <el-col :span="2">
          <el-button
            type="success"
            size="mini"
            v-if="allIds.length>0"
            v-has-permission-code-and="'003500300015'"
            @click="toSave()"
            >全部保存</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button
            type="warning"
            size="mini"
            v-if="btnSh"
            v-has-permission-code-and="'003500300020'"
            @click="toSp()"
            >{{btnTxt}}</el-button
          >
        </el-col>
            <el-col :span="1">
          <el-button
            type="danger"
            size="mini"
            v-has-permission-code-and="'003500300015'"
            @click="rest()"
            >重置</el-button
          >
        </el-col>
          <el-col :span="6" class="box">
            <div class="box2">
              <el-button  type="primary" size="mini" @click="search(-11)" v-if="navi.prev">
                《《
              </el-button>
              <el-date-picker
              size="mini"
                v-model="mth"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>
              <el-button  type="primary" size="mini" @click="search(11)" v-if="navi.next"
                >》》</el-button
              >
            </div>
          </el-col>
        <el-col :span="2" class="box">
          <el-input
            placeholder="设置应出勤天数"
            size="mini"
            title="应出勤天数"
            v-has-permission-code-and="'003500300015'"
            v-model="ndcq"
            autocomplete="off"
          ></el-input>
         </el-col>
         <el-col :span="10" class="box">
         {{msg}}
        </el-col>
      </el-row>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column width="45" label="序">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column width="145" prop="name" label="姓名">
          <template slot-scope="scope">
            <el-tag size="mini"  v-if="scope.row.state>0" type="success" :title="'已完成计算无需更新'">{{
              scope.row.name
            }}</el-tag>
             <el-tag size="mini" v-if="scope.row.state==0" type="warning" :title="'计算未完成'">{{
              scope.row.name
            }}</el-tag>
              
            <el-tag size="mini" type="danger" :title="scope.row.dy">{{
              scope.row.allsal
            }}</el-tag>
          </template></el-table-column
        >
          <el-table-column width="110" prop="bsalX" label="底薪标准"
          ><template slot-scope="scope">
            <el-input
              :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.bsalX"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
       <el-table-column width="90" prop="state" label="状态"
          ><template slot-scope="scope">
            <el-tag size="mini" type="info" v-if="scope.row.state == 0">计算中</el-tag>
            <el-tag size="mini" v-if="scope.row.state<2000 && scope.row.state%100 >= 10">黄</el-tag>
            <el-tag size="mini" v-if="scope.row.state<2000 && scope.row.state%1000 >= 100">李</el-tag>
            <el-tag size="mini" type="warning" v-if="scope.row.state==1000">复核中</el-tag>
            <el-tag size="mini" v-if="scope.row.state == 6000">复核ok</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.state == 6666">待发</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.state == 8888"
              >已发</el-tag
            >
          </template></el-table-column
        >
        <el-table-column width="90" prop="actcq" label="实出勤"
          ><template slot-scope="scope">
            <el-input
              :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.actcq"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="90" prop="qjdays" label="请假天数"
          ><template slot-scope="scope">
            <el-input
              :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.qjdays"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="120" prop="kqrmk" label="考勤备注"
          ><template slot-scope="scope">
            <el-input
              :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.kqrmk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="bsal" label="基本工资"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.bsal"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="kqsal" label="出勤工资"
          ><template slot-scope="scope">
            <el-input
              :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.kqsal"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="70" prop="late" label="迟到"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.late"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="65" prop="ndk" label="漏打卡"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.ndk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="60" prop="kou" label="扣款"
          ><template slot-scope="scope">
            <el-tag size="mini" type="danger" :title="scope.row.dy">{{
              scope.row.kou
            }}</el-tag>
          </template></el-table-column
        >
        <el-table-column width="90" prop="yeji1" label="业绩1"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji1"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="yeji1rmk" label="说明"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji1rmk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="90" prop="yeji2" label="业绩2"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji2"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="yeji2rmk" label="说明"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji2rmk"
              autocompletew="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="90" prop="yeji3" label="业绩3"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji3"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="yeji3rmk" label="说明"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.yeji3rmk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="90" prop="jxkh" label="绩效考核"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.jxkh"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="jxkhrmk" label="绩效备注"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.jxkhrmk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="90" prop="othsal" label="其他工资"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.othsal"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
        <el-table-column width="110" prop="othrmk" label="其他说明"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.othrmk"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
           <el-table-column width="150" prop="remark" label="发工资备注"
          ><template slot-scope="scope">
            <el-input
                   :readonly="scope.row.state>0"
              size="mini"
              v-model="scope.row.remark"
              autocomplete="off"
            ></el-input> </template
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "@/api/cw/salary.js";
export default {
  name: "addsal",
  components: {},
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,

      listData: [],
      allIds: [],
      selected: [],

      mth: "",
      navi: {},
      ndcq: 22,
      selected2: 0,
      msg: "",
      me:{},
      nndSave:true,
      btnTxt:"",
      btnSh:false 
    };
  },
  watch: {
    ndcq: {
      handler() {
        if (this.ndcq) {
          for (let i = 0; i < this.listData.length; i++) {
            let d = this.listData[i];
            d.ndcq = this.ndcq * 1;
            if( d.state<1000 && (!d.actcq ||d.actcq==0)  )
              d.actcq = this.ndcq * 1;
          }
        }
      },
    },
    listData: {
      handler() {
        for (let i = 0; i < this.listData.length; i++) {
          let d = this.listData[i];
          let v1 = (((d.bsalX * d.actcq * 1) / d.ndcq) * 1).toFixed(1) * 1;
          if (!isNaN(v1)) {
            d.bsal = v1;
          }
          let v2 =
            (
              ((d.kqsalX * 1 * (d.ndcq * 1 - d.qjdays * 1)) / d.ndcq) *
              1
            ).toFixed(1) * 1;
          if (!isNaN(v2)) {
            d.kqsal = v2;
          }
          let v3 = -1 * (2 * d.late + 20 * d.ndk);
          if (!isNaN(v3)) {
            d.kou = v3;
          }
          let v4 = (
            d.bsal +
            d.kqsal +
            d.kou +
            d.yeji1 * 1 +
            d.yeji2 * 1 +
            d.yeji3 * 1 +
            d.jxkh * 1 +
            d.othsal * 1
          ).toFixed(1);
          if (!isNaN(v4)) {
            d.allsal = v4;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    
    //重置
    rest() {
      
       if (  this.selected.length == 0) {
        this.$utils.msg.info("请选择操作的行");
        return;                             
        }
        this.$utils.confirm.warning(
          "提示",
          "重置选中的" + this.selected.length + "行吗?",
          () => {
            api.rst(
              this.selected,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          }
        );
    },
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams);
      
      api.toAdd(params, (res) => {
        if( res.data.datas){
              this.listData = res.data.datas;
        }

        if(!this.listData || this.listData.length==0 ){
            this.$utils.msg.success("该月没有数据");
        }else{
            this.ndcq = this.listData[0].ndcq
        }
        this.allIds=[]
        //缓存
        let allIds1000 =[]
        for (let i = 0; i < this.listData.length; i++) {
            let vo = this.listData[i];

            if(this.me.role2=='admin'){
                 if(vo.state==0){
                   this.allIds.push(vo);
                 }else if( this.allIds.length==0){
                    if(vo.state>=1000 && vo.state<2000){
                      allIds1000.push(vo);
                    }
                 }
                if( vo.id == undefined ){ // 如果没有id  
                    this.nndSave = true
                 }
            }else if(this.me.role2=='admin2'){
              if( vo.state<2000 && (vo.state %100) <10 ){
                 this.allIds.push(vo);
              }
            }else if(this.me.role2=='mgr'){
              if( vo.state<2000 && (vo.state %1000) <100 ){
                 this.allIds.push(vo);
              }
            }
         }
            if(this.me.role2=='admin'){
               if( this.allIds.length>0 ){
                  this.btnTxt="计算已完毕，开始复核"
                  this.btnSh=true
               }else if(allIds1000.length>0){
                  this.allIds = allIds1000
                  this.btnTxt="复核完毕,进入【发放方案】"
                  this.btnSh=true
               }else{
                 this.btnSh=false
               }
            }else if(this.me.role2=='admin2'){
              if( this.allIds.length>0 ){
                  this.btnTxt="复核完毕"
                  this.btnSh=true
               }else{
                 this.btnSh=false
               }
            }else if(this.me.role2=='mgr'){
              if( this.allIds.length>0 ){
                  this.btnTxt="复核完毕"
                  this.btnSh=true
               }else{
                 this.btnSh=false
               }
            }
    
         this.navi = res.data.navi;
         this.mth = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
         this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      let parameter = [];
      for (let i = 0; i < this.allIds.length; i++) {
        let vo = this.allIds[i];
        if (!vo.satm) {
          vo.satm = this.mth + "-01";
        }
        delete vo.dy;
        parameter.push(vo);
      }
      api.save(parameter, (res) => {
        this.$utils.msg.success(res.msg);
        this.list();
      });
    },
    //审批
    toSp() {
       if  ( !this.nndSave ) {
        this.$utils.msg.info("请先保存!");
        return;                             
       }

      if (!this.allIds || this.allIds.length == 0) {
        this.$utils.msg.info("没有需要操作的行");
        return;                             
      }
  
      this.$utils.confirm.warning("提示", "确定提交"+this.allIds.length+"条"+this.btnTxt+"吗?", () => {
       
        let params = []
        for (let i = 0; i < this.allIds.length; i++) {
            params.push(this.allIds[i].id)
        }

        api.sp(
          params,
          (response) => {
            this.$utils.msg.success( response.msg );
            this.list();
          },
          (response) => {
            this.$utils.msg.warning( response.msg );
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      let sumVal = 0;

      for (let item of val) {
         this.selected.push(item.id);
         sumVal += (item.allsal*1);
      }
       
       if (this.selected.length > 0) {
        this.msg =
          "已选择: " +
          this.selected.length +
          " 位,税前工资合计: " +
          sumVal.toFixed(0) +
          " 元";
      } else {
        this.msg = "";
      }
    },search(type) {
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.mth = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.mth = this.navi.next;
        } else if (type == 1) {
          // 时间选择器
          this.searchParams.mth = this.month;
        } 
      }
      this.list();
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>

